<template>
  <div class="flex_bet text_line gutter_t_s" v-for="(item, index) in itemsList" :key="index">
    <label class="flex_vcenter text_label" :style="{ 'min-width': labelWidth }">{{ item.title }}</label>
    <div class="flex_item flex_vcenter" v-if="item.type == 'btn'">
      <el-button type="primary" @click="$openRef(item.link)">{{ item.value }}</el-button>
    </div>
    <div class="flex_item flex_vcenter" v-else-if="item.type == 'link'">
      {{ item.elText }}<el-button type="text" @click="$openRef(item.link)">{{ item.value }}</el-button>
      <img v-if="item.value" class="copy_img gutter_l_s" src="/imgs/copy_icon.png" @click="$msg.copy(item.value)" />
    </div>
    <div class="flex_item flex" v-else-if="item.type == 'slot'">
      <slot :name="item.props"></slot>
    </div>
    <div v-else class="flex_item flex_vcenter" :style="item.attr">
      <div v-if="item.type == 'copy'">
        <span>{{ item.value }}</span>
        <img v-if="item.value" class="copy_img gutter_l_s" src="/imgs/copy_icon.png" @click="$msg.copy(item.value)" />
      </div>
      <div v-else-if="item.type == 'address'" class="flex_column" style="margin-top: 8px">
        <div style="color: #000; font-size: 16px">
          {{ item.value[0] }}
        </div>
        <div class="text_label flex_bet flex_center">
          <span>{{ item.value[1] }} {{ item.value[2] }}</span>
          <div>
            <el-button type="primary" @click="openDialog(item, 'dlType')" class="update_btn" v-if="item.dlType">{{ item.dlTypeTitle || '修改' }}</el-button>
            <el-button type="primary" @click="openDialog(item, 'sendType')" class="send_btn" v-if="item.sendType">派单</el-button>
          </div>
        </div>
      </div>
      <div v-else :class="item.color || ''">{{ item.value }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userInfo',
  props: {
    itemList: Array,
    labelWidth: {
      type: String,
      default: '90px'
    }
  },
  watch: {
    itemList: {
      handler(newVal) {
        this.itemsList = newVal.filter(item => !item.disabld)
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      itemsList: []
    }
  },
  methods: {
    openDialog(item, type) {
      if (type == 'dlType') {
        this.$emit('openHandle', item)
      } else if (type == 'sendType') {
        this.$emit('openSendHandle', item)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.text_line {
  min-height: 34px;

  > label {
    // width: 90px;
    height: 34px;
  }

  > div {
    margin-left: 30px;
  }
}
.update_btn {
  padding: 0 10px;
  margin: 10px;
  background-color: #0259e7;
  border-color: #0259e7;
}
.send_btn {
  padding: 0 10px;
  margin: 10px;
}
</style>
